import React from 'react';
import { cn } from '../../utils/cn';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label: string;
  error?: string;
  multiline?: boolean;
}
export function Input({
  className,
  label,
  error,
  multiline = false,
  id,
  ...props
}: InputProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const base = ['w-full bg-brand-gray-900 text-brand-white px-4 py-3', 'border rounded-sm transition-colors duration-200', 'placeholder:text-brand-gray-500', 'focus:outline-none focus:border-brand-teal focus:ring-1 focus:ring-brand-teal', error ? 'border-red-500/60 focus:border-red-500 focus:ring-red-500' : 'border-brand-gray-700'].join(' ');
  return <div className="w-full flex flex-col gap-2" data-id="element-65">
      <label htmlFor={inputId} className="text-xs font-bold text-brand-gray-300 uppercase tracking-widest" data-id="element-66">
        {label}
      </label>

      {multiline ? <textarea id={inputId} className={cn(base, 'min-h-[120px] resize-y', className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-67" /> : <input id={inputId} className={cn(base, className)} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-68" />}

      {error && <span id={`${inputId}-error`} role="alert" className="text-xs text-red-400 mt-0.5" data-id="element-69">
          {error}
        </span>}
    </div>;
}